<app-header></app-header>
<main class="content">
  <p-toast position="top-right"></p-toast>
  <div class="container-fluid">
    <router-outlet></router-outlet>
  </div>
</main>
<app-footer></app-footer>
